<template>
  <section class="g-wrapper">
    <header-com/>
    <div class="g-container" v-if="type == 'one'">
      <div class="f32">一、适用范围</div>
      <div class="f26 s-title"><span>适用范围：</span>凡在心爱之物（天津）科技有限公司（以下简称“包拯”）即“包拯”官方渠道，包括但不限于经包拯微信公众号、小程序、包拯客服预约、客户端、网站下单并支付成功的用户；</div>
      <div class="f26 s-title"><span>质保开始时间：</span>除本协议约定的非质量保障范围外，服务物品自包拯取送人员送达您手中或快递发出经您确认签收之日起，根据您订单提交的服务类型（详见下表）约定的质保期限截止日止。超出约定期限，出现任何服务质量问题包拯不再提供任何保障措施，返工产生的服务费用由您额外承担；
      </div>
      <div class="f26 s-title"><span>质量保障服务方式：</span>质保期内，包拯为您免费提供订单约定服务项不超过三次返工服务，超过三次仍未解决，包拯将退还该笔订单未解决项目的服务费用。
      </div>
      <img class="img1" src="/images/public/policy1.png"/>
      <div class="f32"> 二、非质量保障范围</div>
      <div class="14 s-title"><span>以下情况不属于质保范围：</span><br/> 1. 超过包拯质保期有效期限； <br/>2. 无保修卡、订单截图，保修商品与原订单不符；<br/>3.
        人为因素造成，包括但不限于自行清洗，自行上色，自行缝补，自行更换配件，重物挤压导致的变形（建议考虑磨损等类型后果）等行为；<br/>4. 不可抗力因素造成；<br/>5. 超出正常使用条件，使用不当，导致的问题或损伤；<br/>6.
        恶意损坏保修卡内容、产品信息，包括模糊破坏、自行撕毁、篡改等；<br/>7. 其他非包拯提供服务项目，包括但不限于在设计、制造、质量等问题而导致的故障和损坏；<br/>8. 非订单约定服务项目；<br/>9. 日常使用导致的正常损耗；
      </div>
       <br/>
      <div class="f32">三、邮寄方式及邮寄地址</div>
      <div class="f26 s-title"><span>1. 邮寄方式：</span>申请售后质保时推荐使用顺丰物流，包拯承担运费、物流标准化包装费及2元（含）以内保价费，但请您务必邮寄到付。除上述费用外，超出2元（不含）的保价费或其他增值服务费用需由您自行承担。未保价或未足额保价的物品发生丢失、破损的，包拯不承担责任。</div>
      <div class="f26 s-title"><span>2. 寄方邮寄信息：</span>邮寄时服务物品内务必放入纸条，注明您的名字、手机号、微信号、服务项目及申请售后项目信息。
      </div>
      <div class="f26 s-title"><span>3. 包拯收件地址：</span>
      </div>
      <div class="f26 s-title"><span>收件人：</span>展昭</div>
      <div class="f26 s-title"><span>地址：</span>天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</div>
      <div class="f26 s-title"><span>收件电话：</span>17526857604/4000520618 </div>
      <!-- <div class="f32 mt40"> 三.售后服务收费标准</div>
      <img class="img2" src="/images/public/policy2.png"/>
      <div class="f32"> 四.售后申请注意事项</div>
      
      <div class="f26 s-title"><span>地址：</span>广州白云区均禾街道罗岗村十三社风水基街8-1号二楼 包拯-修复中心(广州)</div>
      <div class="f26 s-title"><span>注意：</span>包里务必放纸条，写上名字，手机号，微信号，服务项目，申请售后，申请售后时需明确服务是由哪个修复中心负责；</div> -->
    </div>
    <div class="g-container" v-if="type == 'two'">
      <div class="f32">一、适用范围</div>
      <div class="f26 s-title mt40">适用于所有包拯官方下单的客户，包括但不限于微信公众号，包拯客服，小程序、客户端、网站等渠道。<br/>【审慎阅读】您在下单之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的条款、法律适用和争议解决条款。免除或限制责任的条款将以粗体标识，您应重点阅读。若您对协议有任何疑问，可向包拯客服咨询。
        <br/>【下单动作】当您在包拯官方平台下单后，即表示您已充分阅读、理解并接受本协议的全部内容，并与包拯达成一致，成为包拯 “用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止下单。
      </div>
      <div class="f32 mt40">二、免责条款</div>
      <div class="f26 s-title">
        <div class="mt20">1.下单成功后，用户需提前查看发送到包拯的物品中是否有除需服务之外物件，包括不限于包内现金，银行卡，证件，防尘袋，非服务项目的配套卡包，肩带等，如有丢失和损伤，包拯不对此部分负责；
        </div>
        <!-- <div class="mt20">2.针对包邮城市，建议您使用顺丰寄付，包拯将自动为您提供25元运费补贴，直接充值入包拯账户，以便订单结算的时候减免25元，如申请售后所产生的物流费也执行此规则；</div> -->
       
        <div class="mt20">
          2.包拯目前仅对{{$store.state.takeSendCity}}、沈阳、重庆、上述{{$store.state.takeSendNum}}个城市提供包邮服务，其他城市包拯暂不提供包邮服务；
        </div>
        <div class="mt20">
          3.针对包邮城市包拯承担运费及物流标准化包装费，建议您使用顺丰物流，但请您务必邮寄到付。除上述费用外，保价费或其他增值服务费用需由您自行承担，未保价的物品发生丢失、破损的，包拯不承担责任。
        </div>

        <div class="mt20">
          4.适用法律允许的范围内，对于以下损失和损害，对用户不承担任何责任，无论其是基于陈述（欺诈性陈述除外）、侵权（包括过失）或任何明示或默示条款：双方不能合理预见的与产品供应以及相关服务有关的任何损失或损害或者用户与收货人对相关服务的使用有关的任何损失或损害；
        </div>
        <div class="mt20">5.对于诊断方案中明确指出按照包拯现有工艺技术无法服务的项目，或无法准确服务的项目，用户知悉后仍坚持要求包拯进行服务而造成未达服务标准甚至损坏，包拯不为此承担任何责任；</div>
        <div class="mt20">
          6.经诊断后，服务无法继续，包括不限于物品老化严重无法修复，修复方案不满意等情况，包拯会将原品寄回，寄回快递费用由包拯承担，用户需在1周（7个自然日）内确认地址，超期后包拯不对期间物品有可能发生的所有风险负责，超期半年后，物品将归包拯自行处理；
        </div>
        <div class="mt20">7.对确实不易洗染或有不能除净的牢固性污渍，包拯告知用户洗染效果，用户仍坚持继续服务造成的包括不限于效果不明显，不满意的情况，包拯不为此负责；</div>
        <div class="mt20">
          8.存在不可预测、有潜在变化的情形：如虫蛀的，清洗后出现掉毛、破损、露底、异味扩散，现洞和破损面积扩大的，皮质内部严重老化，擦拭后掉皮、掉色、破损、断裂、破洞、破皮情况；logo严重老化，触碰后出现破损、划伤、变形；内衬吹风除尘或触碰时，由于内衬内部已经老化，造成脱丝、破洞、缩水、起泡情况，包拯不为此负责；
        </div>
        <div class="mt20">9.原有化学腐蚀的和重度污物处掩盖的顽渍、污渍腐蚀面料，在正常护理后明显暴露或破损的，包拯不为此负责；</div>
        <div class="mt20">
          10.羽绒服、棉衣正常清洗或护理后里料异味外渗，填充物污染面料的；裘皮衣物洗涤后，出现面料或面料反面或者内里填充物污染面料正面等现象的；经长期晾挂，阳光长期照射造成面料自然脆化，经正常护理后出现破损的，包拯不为此负责；
        </div>
        <div class="mt20">11.对于确实不易修复或又无法根除的污渍、磨损、破损、开裂、划痕、断裂、压痕、变型等情况导致未能达到质量标准的，包拯不为此负责；</div>
        <div class="mt20">12.经检测物品不符合修复及质量本身存在问题或物品本身为假货，导致修复时无法达到质量标准的，包拯不为此负责；</div>
        <div class="mt20">13.物品邮寄包拯接收后未修复前本身就存在破损、损伤的情况，包拯不为此负责；</div>
        <div class="mt20">14.物品邮寄过程中发生的意外现象，包括不限于物品积压变形，磨损，丢件等情形，由快递公司承担；</div>
        <div class="mt20">
          15.在服务中发生的难以认定的争议问题，或者用户对于结果有异议，经营者和消费者可以约定，送至第三方机构当地洗染行业协会进行鉴定质检或其它有资质的机构鉴定，鉴定费由送鉴定方先行垫付，最终处理方案依照鉴定结果执行，鉴定费由责任方承担。
        </div>
        <div class="mt20">16.服务完成并由用户确认效果后，用户需在2周（14个自然日）确认地址以寄回‘，超期后包拯不对期间物品有可能发生的所有风险负责，超期半年后，物品将归包拯自行处理；</div>
      </div>
      <div class="f32 mt40">三、补充信息</div>
      <div class="s-title f26"> 
        <div class="mt20">
          1.下单前建议与官方客服取得联系，渠道包括但不限于微信公众号，包拯客服，包拯热线电话，包拯微博；
        </div>
        <div class="mt20">
          2.如需要包拯提供发票，请联系包拯客服提供发票信息，发票将与用户受服务物品一同发出，如在收到包裹后需要发票，联系客服提供发票信息后，包拯将开具发票快递至用户，快递费用到付或由用户承担。
        </div>
        
        
      </div>
      <div class="f32 mt40">四、法律适用、管辖与其他</div>
      <div class="f26 s-title">
        <div class="mt20">
          1.本协议的解释权归包拯经营者即心爱之物（天津）科技有限公司所有。如果其中有任何条款与国家的有关法律相抵触，则以国家法律的明文规定为准；
        </div>
        <div class="mt20">
          2.本协议之订立、生效、解释、修订、补充、终止、执行与争议解决等均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例；
        </div>
        <div class="mt20">
          3.您因使用包拯服务所产生及与包拯服务有关的争议，由包拯与您协商解决。协商不成时，任何一方均可向包拯经营者所在地有管辖权的人民法院提起诉讼；
        </div>
        <div class="mt20">
          4.本协议任一条款被视为废止、无效或不可执行，并不影响本协议其余条款的有效性及可执行性。
        </div>
        <div class="mt20">
          4.本协议任一条款被视为废止、无效或不可执行，并不影响本协议其余条款的有效性及可执行性。
        </div>
        
      </div>
      <div class="f26 mt20 s-title" style='color:#333;font-weight:500'> 
        您下单成功后即视为您完全接受本协议，在下单之前请您再次确认已知悉并完全理解本协议的全部内容。
      </div>
      
    </div>
    <div class="g-container" v-if="type == 'three'">
      <div class="f32">特别提示</div>
      <div class="f26 mt40 s-title">
        欢迎访问包拯（以下简称“包拯”或“我们”）官方网站及其移动客户端软件、应用程序（以下简称“包拯工作室”）以使用我们提供的产品及服务。我们在此特别提醒您（或称“用户”），在您注册成为用户前，请认真阅读《包拯用户协议》（以下简称“协议”），确保您充分理解本协议中各项条款。您确认服务条款并完成注册后，本协议即构成对双方具有约束力的有效法律文件。 包拯为广大用户提供的产品及服务，均遵守以下服务条款及使用准则，请仔细阅读。我们向您提供的服务还需要您遵守在包拯工作室公布的其他条款及服务准则（包括服务说明及使用帮助及包拯不时公布的各项公告、规则等），您同时应一并予以知晓、理解并接受。同意将其作为确定双方权利义务的依据。 如果您不同意接受本协议及相关协议、公告、规则或其中任何条款约定，您应立即停止注册、登录或使用本协议所涉服务。您的注册、登录、使用或通过网址链接进入等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
      </div>
      <div class="f32 mt40">一、包拯账户</div>
      <div class="f26 s-title">
        <div class="mt20">
          为了使用我们提供的服务，您需要注册一个包拯账户，账户名即为您所提供的注册手机号码。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得包拯账户并成为包拯用户。您可在账户中查询到您的订单记录，包括邮寄信息、服务费用等记录。您的账户关联您的个人信息及包拯工作室商业信息，您的账户由您自行保管。您应负责维护您账户的安全，对您所使用的账户进行保密，并限制第三方使用/访问您的计算机或移动设备。账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，包拯并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。如果您未满18周岁，您需要在父母或监护人的参与下使用服务。我们保留自行决定终止提供服务、关闭账户、删除或编辑内容以及取消订单的权利。
        </div>
        <div class="mt20">如发现任何未经授权使用您账户登录包拯工作室或其他可能导致您账户遭窃、遗失的情况，建议您立即通知包拯。您理解包拯对您的任何请求采取行动均需要合理时间，且包拯应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除包拯存在法定过错外，包拯不承担责任。</div>
      </div>
      <div class="f32 mt40">二、包拯服务</div>
      <div class="s-title f26">
        <div class="mt20">
          包拯是为用户提供洗护修复服务的商家。用户通过包拯服务，在双方之间达成服务协议，并承担相应的权利和义务。由于相关政策规定，部分物品我们无法提供清洗修复服务。如因洗护不规范造成物品损坏或取送过程中因包拯原因造成物品损坏或丢失，包拯将按照《包拯理赔细则》等相关条款承担相应的赔偿责任。
        </div>
        <div class="mt20">
          除包拯工作室明示的收费业务外，如未来包拯向您收取其他合理费用，包拯会以本协议约定的方式通知您。
        </div>
      </div>
      <div class="f32 mt40">三、服务开始和提供</div>
      <div class="f26 s-title">
        <div class="mt20">
          本条款所述“服务订单”，是指包拯接受用户委托，在客户下单成功、取送人员成功领取物品后，服务方可生效，用户同时应向包拯支付服务价款，用户未支付价款的，包拯有权拒绝提供服务。如服务订单无法履行（例如服务订单下单失败，取送人员未成功取到物品），我们将与您进行联系。在包拯履行完与用户达成的服务合同后，用户可作出相应的评价，以使包拯进一步提高服务质量。
        </div>
        <div class="mt20">
          因下列情况导致包拯无法完成或延迟取送业务的，包拯不承担责任： <br/>1、用户提供的信息错误、地址不详细等原因导致的； <br/>2、取送物品时无人接应或签收，导致无法取送或延迟取配送的； <br/>3、情势变更因素导致的；<br/> 4、不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。
        </div>
      </div>
      <div class="f32 mt40">四、信息发布</div>
      <div class="f26 s-title">
        <div class="mt20">
          根据国家法律法规变化及包拯工作室运营需要，包拯有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在包拯工作室上即生效，并取代此前相关内容，您应不时关注本网站公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用；如您继续使用，即视为知悉变动内容并同意接受。包拯最新的服务报价、优惠活动将公布于包拯工作室。我们会尽最大努力提高该信息的准确性，由于众所周知的互联网技术因素等客观原因存在，本平台显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解。如果您认为上述信息让您无法接受，您可选择取消订单、拒绝使用，并联系客服人员通知我们，我们将立即更新发布的信息，并依照相关的管理政策对其进行处理。
        </div>
        <div class="mt20">
          用户可在包拯工作室发表评论、意见和其他内容；但前提是该等内容须不违反中国现行法律法规及其他规范性文件的要求，不得含有非法、淫秽、威胁、诽谤、侵犯隐私、侵犯知识产权，或以其他形式对第三方权利构成侵犯等内容。包拯有保留、清除、或编辑这些内容的权利，并对用户所张贴的内容进行经常性的审查。用户需声明和保证，对于因其所提供的内容引起的对包拯的名誉侵犯和损害，须进行赔偿。
        </div>
        <div class="mt20">
          对于用户在包拯发表的内容及提交的信息，您同意在法律规定的保护期限内免费授予包拯及关联公司获得全球排他的许可使用权利及再授权给其他第三方使用并以可自身名义对第三方侵权行为取证及提起诉讼的权利。您同意包拯及其关联公司存储、使用、复制、转载、修改、改编、出版、翻译、创作衍生作品、分发和展示这些内容或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。
        </div>
      </div>
      <div class="f32 mt40">五、隐私</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯可能会要求用户提供其手机号码及位置等个人信息，以便实现取送、发送物品明细等重要功能。包拯会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，尽最大努力使您的信息不被泄漏、毁损或丢失且包拯不会向任何第三方提供用户信息，但以下特定情形除外：<br/>1、包拯根据法律法规规定或有权机关的指示提供的个人 信息；<br/>2、用户自行向第三人公开其个人信息；<br/>3、任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人信息的泄露；<br/>4、由于用户将其用户密码告知他人或与他人共享注册账户与密码，由此导致的任何个人信息的泄露，或其他非因包拯原因导致的个人信息的泄露。
        </div>
      </div>
      <div class="f32 mt40">六、客户服务</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯建立专业的客服团队，并建立完善的客户服务制度，从技术、人员和制度上保障用户提问及投诉渠道的畅通，为用户提供及时的疑难解答与投诉反馈。
        </div>
      </div>
      <div class="f32 mt40">七、知识产权</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯工作室包含的全部智力成果包括但不限于数据库、网站设计、文字和图表、软件、照片、录像、音乐、声音及其前述组合，软件编译、相关源代码和软件 (包括小应用程序和脚本) 的知识产权权利均归包拯所有。用户不得为商业目的复制、更改、拷贝、发送或使用前述任何材料或内容。
        </div>
        <div class="mt20">
          包拯名称中包含的所有权利 (包括商誉和商标) 均归包拯 所有。
        </div>
        <div class="mt20">
          用户接受本协议即视为用户主动将其在包拯客户端发表的任何形式的信息的著作权，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有其他可转让权利无偿独家转让给包拯所有，包拯有权利就任何主体侵权单独提起诉讼并获得全部赔偿。本协议属于《中华人民共和国著作权法》第二十五条规定的书面协议，其效力及于用户在包拯发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。
        </div>
        <div class="mt20">
          用户在使用包拯服务过程中不得非法使用或处分包拯或他人的知识产权权利。用户不得将已发表于包拯的信息以任何形式发布或授权其它网站（及媒体）使用。
        </div>
      </div>
      <div class="f32 mt40">八、服务的修改和终止</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯始终在不间断地改进并提供优质的服务。为此，包拯可根据需要随时调整某项操作功能，或对提供的服务设置新的条款准则，也有权暂停或彻底停止某项服务。基于此，包拯会向用户发出通知，用户有权随时停止使用包拯提供的服务。如用户违反其在本服务条款及使用条件中的行为规范，包拯有权随时终止向用户提供所述服务。对因用户本身物品存在问题所致的任何纠纷赔偿，包拯不予承担。
        </div>
      </div>
      <div class="f32 mt40">九、责任限制</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯负责按当前状态为您提供服务。但包拯对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，包拯并不承担相应的违约责任：<br/>1、因政府行为譬如政策或法规的变更、司法行政命令、战争、自然灾害等不可抗力因素；<br/>2、因通讯网络线路中断、电力供应故障、黑客攻击、他人蓄意破坏、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成网站的暂时性关闭等任何影响网络正常运营的公共服务因素或第三人因素；<br/>3、在包拯已尽善意管理的情况下，正常或紧急的系统维护、系统升级，或者因网络拥塞而导致本网站不能访问而造成的本网站所提供的信息及数据的延误、停滞或错误等设备与系统故障、网络信息与数据安全。 包拯不对用户所发布信息的保存、修改、删除或储存失败负责，对网站上的非因包拯故意所导致的排字错误、疏忽等不承担责任。包拯无义务改善或更正用户在本网站所发布信息的任何部分的疏漏、错误之处。
        </div>
      </div>
      <div class="f32 mt40">十、违约责任</div>
      <div class="f26 s-title">
        <div class="mt20">
          1、发生如下情形之一的，视为您违约：<br/>⑴ 使用包拯工作室相关应用程序违反有关法律法规规定的；<br/>⑵ 如果包拯发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的；<br/>⑶ 违反本协议或与本协议有关的内容约定的。
        </div>
        <div class="mt20">
          2、您的行为构成违约的，包拯有权不经通知随时采取以下一项或多项措施：<br/>⑴ 您在包拯工作室相关应用程序上发布的信息构成违约的，立即对相应信息进行删除、屏蔽处理；<br/>⑵ 警告、限制使用部分或全部功能；<br/>⑶ 封禁、注销您的账户，终止向您提供服务；<br/>⑷ 要求您承担违约责任。
        </div>
        <div class="mt20">
          3、赔偿责任 如您的行为使包拯及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿包拯及/或其关联公司的上述全部损失。 如您的行为使包拯及/或其关联公司遭受第三人主张权利，包拯及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。 如因您的行为使得第三人遭受损失或您怠于履行调处决定、包拯及/或其关联公司出于社会公共利益保护或第三人权益保护目的，您同意委托包拯使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成包拯的全部损失。
        </div>
      </div>
      <div class="f32 mt40">十一、适用法律</div>
      <div class="f26 s-title">
        <div class="mt20">您同意本服务条款和使用准则、以及您和包拯之间发生的任何争议纠纷均适用中华人民共和国法律。</div>
      </div>
      <div class="f32 mt40">十二、争议纠纷</div>
      <div class="f26 s-title">
        <div class="mt20">
          您和包拯之间发生的任何形式的争议均应友好协商解决，若协商解决未果，任一方有权将争议提交包拯住所地人民法院诉讼解决。
        </div>
      </div>
      <div class="f32 mt40">十三、协议变更和可分性</div>
      <div class="f26 s-title">
        <div class="mt20">
          为更好地提供服务并符合相关监管政策，我们有权不定期地对上述协议进行变更。请您定期查阅本协议。我们将以网站公告的方式进行公示，并列明最近的修改日期。如您不同意我们对相应条款作出的修改，您应立即停止使用包拯所提供的服务，修改事项对您不产生效力；如您在修改事项生效后仍继续使用包拯平台服务，则视为您同意已生效的修改事项。如果本协议中任何一条被视为废止、无效或因任何理由不可执行的条款，该条款应视为可分割的且不影响任何其余条款的有效性和可执行性。
        </div>
      </div>
      <div class="f32 mt40">十四、通知和公告</div>
      <div class="f26 s-title">
        <div class="mt20">
          包拯将通过微信、短信、官网发布通知，并通过其它方式与用户进行沟通。您同意我们用以上方式为您提供所有协议、通知、公告及其他信息，且均符合相关的法律法规。如果我们以上述形式向您发布协议、通知、公告及其他信息，将视为您已收到所有协议、声明、公告和其它信息。包拯在法律允许最大范围内对本协议拥有解释权与修改权。
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'policy',
    data () {
      return {
        type: 'one'
      }
    },
    beforeRouteLeave (to, from, next) {
      document.title = '包拯'
      next()
    },
    created () {
      this.type = this.$route.query.type || 'one'
      if (this.type === 'one') {
        document.title = '包拯售后政策'
      } else {
        document.title = '包拯售前免责条款'
      }
    }
  }
</script>

<style scoped lang="scss">
  .g-container {
    padding: 106px 32px 0;
    img {
      width: 100%;
    }
    .f32 {
      font-family: PingFangSC-Medium;
      line-height: 44px;
    }
    .img1 {
      margin: 40px 0;
    }
    .img2 {
      margin-bottom: 40px;
    }
    .s-title {
      color: #9B9B9B;
      line-height: 44px;
    }
    .mt40 {
      margin-top: 40px;
    }
    .mt20 {
      margin-top: 20px;
    }
    span {
      color: #4A4A4A;
    }
  }
  .g-wrapper{
    padding-bottom: 60px;
  }
</style>
